import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { title: String, url: String }

  async share() {
    const shareData = {
      title: this.titleValue,
      url: this.urlValue || window.location.href
    }

    if (navigator.share) {
      try {
        await navigator.share(shareData)
      } catch (err) {
        if (err.name !== "AbortError") {
          this.copyToClipboard(shareData.url)
        }
      }
    } else {
      this.copyToClipboard(shareData.url)
    }
  }

  async copyToClipboard(url) {
    try {
      await navigator.clipboard.writeText(url)
      this.element.querySelector("[data-share-target='label']").textContent = "Lien copié !"
      setTimeout(() => {
        this.element.querySelector("[data-share-target='label']").textContent = "Partager"
      }, 2000)
    } catch {
      window.prompt("Copier le lien :", url)
    }
  }
}
